import React from 'react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../data/products';
import './About.css';

const directors = [
  {
    name: 'Utsav Singh',
    role: 'Director – Exports & Managing Director',
    desc: 'Utsav Singh leads the strategic vision and global expansion of OM Cares. With strong experience in manufacturing and international business development, he focuses on building global partnerships and expanding the company\'s footprint in international markets. His vision is to position OM Cares as a trusted supplier in both domestic and export markets.',
    image: '/images/utsav.jpeg',
    color: '#1565C0',
  },
  {
    name: 'Mithilesh Aade',
    role: 'Director – Marketing & Business Development',
    desc: 'Mithilesh Aade drives the marketing strategy and growth initiatives for OM Cares. He plays a key role in identifying new market opportunities, building distribution networks, and strengthening relationships with institutional buyers and partners. His focus is on expanding brand presence across healthcare, retail, and institutional supply.',
    // image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80',
    image: '/images/mithilesh.jpeg',
    color: '#2C5F2E',
  },
  {
    name: 'Yogiraj Khanvilkar',
    role: 'Director – Business Development',
    desc: 'Yogiraj Khanvilkar is responsible for developing new business opportunities and strengthening client relationships for OM Cares. He works closely with partners, distributors, and institutional buyers to expand the company\'s market presence. With a strong focus on partnerships and strategic growth, he builds long-term collaborations across industries.',
    image: '/images/yogiraj.jpeg',
    color: '#B8982A',
  },
];

const milestones = [
  { year: '2015', title: 'Founded', desc: 'Established in Vasai, Maharashtra' },
  { year: '2017', title: 'ISO Certified', desc: 'Achieved ISO 9001:2015' },
  { year: '2019', title: 'FDA Approved', desc: 'Medical product line approved' },
  { year: '2021', title: 'MSME Registered', desc: 'Make in India certified' },
  { year: '2024', title: '10 Product Lines', desc: 'Full portfolio launched' },
];

export default function About() {
  return (
    <main className="about-page">

      {/* Hero */}
      <section className="about-hero">
        <div className="about-hero-bg" />
        <div className="container about-hero-inner">
          <div className="about-hero-text">
            <span className="section-tag">Who We Are</span>
            <h1>Trusted Healthcare<br /><em>Manufacturer</em></h1>
            <p>
              OM Cares is a trusted manufacturer and supplier of high-quality rubber, silicone, and polymer-based healthcare, consumer, and utility products — designed to improve safety, hygiene, and everyday comfort across India and beyond.
            </p>
            <div className="about-certs">
              {companyInfo.certifications.map(c => (
                <span key={c} className="cert-tag">{c}</span>
              ))}
            </div>
          </div>
          <div className="about-hero-img">
            <img src="https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600&q=80" alt="OM Cares Manufacturing" />
            <div className="about-hero-badge">
              <div className="ahb-item"><span className="ahb-val">10+</span><span className="ahb-label">Sectors</span></div>
              <div className="ahb-div" />
              <div className="ahb-item"><span className="ahb-val">ISO</span><span className="ahb-label">9001:2015</span></div>
              <div className="ahb-div" />
              <div className="ahb-item"><span className="ahb-val">FDA</span><span className="ahb-label">Approved</span></div>
            </div>
          </div>
        </div>
      </section>

      {/* About Description */}
      <section className="about-desc-section">
        <div className="container about-desc-inner">
          <div className="about-desc-block">
            <span className="section-tag">Our Story</span>
            <h2 className="section-title">Built on Expertise,<br /><em>Driven by Care</em></h2>
            <p>
              Built on strong manufacturing expertise in precision rubber and silicone molding, OM Cares focuses on developing reliable products that serve multiple sectors including healthcare, personal care, baby care, sports, fitness, laboratories, hospitality, and household applications.
            </p>
            <p>
              Our product range combines durability, safety, and innovation — ensuring solutions that meet the evolving needs of hospitals, institutions, distributors, retailers, and consumers. Every OM Cares product is developed with attention to quality, functionality, and long-term performance, making it suitable for both professional and everyday use.
            </p>
            <p>
              With a commitment to quality manufacturing, customer trust, and continuous product development, OM Cares aims to become a reliable brand in the healthcare and consumer product space.
            </p>
          </div>
          <div className="about-vm-block">
            <div className="vm-card vision">
              <div className="vm-icon">🌍</div>
              <h3>Our Vision</h3>
              <p>To become a globally trusted brand providing innovative and reliable rubber and silicone solutions that enhance health, safety, and daily living.</p>
            </div>
            <div className="vm-card mission">
              <div className="vm-icon">🎯</div>
              <h3>Our Mission</h3>
              <ul>
                <li>Deliver high-quality and safe products across healthcare and consumer sectors</li>
                <li>Continuously innovate through advanced molding and material technology</li>
                <li>Build long-term partnerships with distributors, institutions, and customers</li>
                <li>Promote hygienic and sustainable product solutions</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="timeline-section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Our Journey</span>
            <h2 className="section-title">Milestones That Define Us</h2>
          </div>
          <div className="timeline">
            {milestones.map((m, i) => (
              <div key={i} className={`tl-item ${i % 2 === 0 ? 'left' : 'right'}`}>
                <div className="tl-content">
                  <div className="tl-year">{m.year}</div>
                  <h4>{m.title}</h4>
                  <p>{m.desc}</p>
                </div>
                <div className="tl-dot" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Leadership Team */}
      <section className="team-section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Leadership</span>
            <h2 className="section-title">The Team Behind OM Cares</h2>
            <p className="section-desc">Experienced leaders driving quality, innovation, and growth across every sector we serve.</p>
          </div>
          <div className="team-grid">
            {directors.map((d, i) => (
              <div key={i} className="director-card" style={{ '--dir-color': d.color }}>
                <div className="dc-img-wrap">
                  <img src={d.image} alt={d.name} />
                  <div className="dc-color-bar" style={{ background: d.color }} />
                </div>
                <div className="dc-body">
                  <h3>{d.name}</h3>
                  <span className="dc-role" style={{ color: d.color }}>{d.role}</span>
                  <p>{d.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta">
        <div className="container about-cta-inner">
          <h2>Want to Partner With Us?</h2>
          <p>We work with hospitals, distributors, retailers, and institutions across India. Let's build something together.</p>
          <div className="about-cta-btns">
            <Link to="/contact" className="btn-primary">Get in Touch</Link>
            <Link to="/products" className="btn-outline-light">View Products</Link>
          </div>
        </div>
      </section>

    </main>
  );
}
